import beyowi from '../assets/beyowi.png'
import freetaps from '../assets/freetaps.png'
import jcdecaux from '../assets/jcdecaux.jpg'
import jetour from '../assets/jetour.png'

const experienceFiles = [
  {
    "year": "Current",
    "items": [
      {
        "id": 0,
        "name": "JCDecaux.png",
        "logo": jcdecaux,
        "height": "50%",
        "width": "80%",
        "details": [
          {"key": "Title", "value": "Data Scientist"},
          {"key": "Period", "value": "March 2019 - Present"},
          {"key": "Company", "value": "JCDecaux"},
          {"key": "Location", "value": "Neuilly-sur-Seine, France"},
          {"key": "Type", "value": "Full-time job"},
          {"key": "Link", "value": "https://www.jcdecaux.com/"},
          {"key": "Technologies", "value": "Scala, Apache Spark, Python, AWS"}
        ]
      }
    ]
  },
  {
    "year": "2018",
    "items": [
      {
        "id": 1,
        "name": "Jetour.jpg",
        "logo": jetour,
        "height": "50%",
        "width": "80%",
        "details": [
          {"key": "Title", "value": "Software engineer"},
          {"key": "Period", "value": "June 2018 - August 2018"},
          {"key": "Company", "value": "Jetour Travel Limited"},
          {"key": "Location", "value": "Hong Kong"},
          {"key": "Type", "value": "Internship"},
          {"key": "Link", "value": "https://www.jetour.com.hk/"},
          {"key": "Technologies", "value": "React Native, Django, Node.js"}
        ]
      },
    ]
  },
  {
    "year": "2017",
    "items": [
      {
        "id": 2,
        "name": "Eaupen.jpg",
        "logo": freetaps,
        "height": "50%",
        "width": "70%",
        "details": [
          {"key": "Title", "value": "Full-stack developer"},
          {"key": "Period", "value": "October 2017 - May 2018"},
          {"key": "Organization", "value": "Eaupen"},
          {"key": "Location", "value": "Bordeaux, France"},
          {"key": "Type", "value": "Volunteering"},
          {"key": "Link", "value": "https://freetaps.earth/"},
          {"key": "Technologies", "value": "React Native, Django"}
        ]
      },
      {
        "id": 3,
        "name": "Beyowi.jpg",
        "logo": beyowi,
        "height": "50%",
        "width": "70%",
        "details": [
          {"key": "Title", "value": "Front-end developer"},
          {"key": "Period", "value": "July 2017 - August 2017"},
          {"key": "Company", "value": "Beyowi"},
          {"key": "Location", "value": "Paris, France"},
          {"key": "Type", "value": "Internship"},
          {"key": "Link", "value": "https://beyowi.com/"},
          {"key": "Technologies", "value": "Java for Android"}
        ]
      }
    ]
  }
]

export default experienceFiles;